import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actions from "../actions/project";
import Modal from "@material-ui/core/Modal";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Slide from "@material-ui/core/Slide";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import ImageUploader from "react-images-upload";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  button: {
    "margin-top": "15px",
  },
  fab: {
    "margin-top": "15px",
    background: "linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)",
  },
  card: {
    maxWidth: 345,
  },
  image: {
    maxWidth: "400px",
  },
}));

function ProjectUpdate({
  match: {
    params: { projectId },
  },
  selected,
  deleteProject,
  patchProject,
  getProject,
  wait,
}) {
  const [open, setOpen] = React.useState(false);
  const [openDelete, setOpenDelete] = React.useState(false);
  const classes = useStyles();

  React.useEffect(() => {
    getProject(projectId);
  }, [projectId]);

  React.useEffect(() => {
    selected &&
      setValues({
        ...values,
        title: selected.title,
        comments: selected.comments,
      });
  }, [selected]);

  const [values, setValues] = React.useState({
    title: "",
    comments: "",
  });

  const handleClickDelete = (event) => {
    deleteProject(projectId);
  };

  const handleChange = (name) => (event) => {
    setValues({ ...values, [name]: event.target.value });
  };

  const handleClickPatch = (event) => {
    console.log(values, "values");
    patchProject(projectId, values.title, values.comments);
    setOpen(false);
  };

  const handleChangeImage = (pictureFiles, pictureDataURLs) => {
    setValues({
      ...values,
      file: pictureFiles[0],
      fileSourse: URL.createObjectURL(pictureFiles[0]),
    });
    // console.log(values,'values', URL.createObjectURL(pictureFiles[0]))
  };

  if (wait) {
    return <div>Waiting...</div>;
  }

  if (!selected) {
    return <div>Not found</div>;
  }

  return (
    <>
      <h1>Project | {selected.title}</h1>
      <div>
        <form className={classes.root} noValidate autoComplete="off">
          <TextField
            id="title"
            label="New title"
            value={values.title}
            onChange={handleChange("title")}
          />
          <div style={{ marginTop: "20px", display: "flex" }}>
            <TextField
              style={{ width: "50vw" }}
              id="project-comments"
              label="Project Description"
              value={values.comments}
              onChange={handleChange("comments")}
              inputProps={{ maxLength: 2000 }}
              multiline
            />
            <Typography
              style={{ alignSelf: "end", marginLeft: "10px" }}
              id="char-count"
              onChange={handleChange("comments")}
            >{values.comments.length + '/2000'}</Typography>
          </div>
        </form>
      </div>
      <div>
        <Button
          variant="contained"
          color="primary"
          style={{
            background: "linear-gradient(45deg, #1c7ff4 30%, #45adf7",
            verticalAlign: "bottom",
            marginRight: "15px",
          }}
          onClick={handleClickPatch}
        >
          Update
        </Button>
        <Button
          variant="contained"
          className={classes.button}
          color="secondary"
          onClick={() => setOpenDelete(true)}
          aria-label="delete"
        >
          <DeleteIcon />
          Delete project
        </Button>
      </div>

      <Modal
        aria-labelledby="update-modal-title"
        aria-describedby="update-modal-description"
        className={classes.modal}
        open={openDelete}
        onClose={() => setOpenDelete(false)}
      >
        <Slide direction="up" in={openDelete} mountOnEnter unmountOnExit>
          <div className={classes.paper}>
            <h2> Are you shure? </h2>
            <Button
              variant="contained"
              className={classes.button}
              color="secondary"
              onClick={() => handleClickDelete()}
              aria-label="delete"
            >
              <DeleteIcon />
              Yes, Delete project
            </Button>
          </div>
        </Slide>
      </Modal>
    </>
  );
}

const mapStateToProps = (state) => state.project;

const mapDispatchToProps = (dispatch) => bindActionCreators(actions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ProjectUpdate);
